import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export const AuthShell = ({ title, children, testid }) => (
  <div className="min-h-[100svh] relative grid place-items-center px-5 py-12 bg-[#000000] grain overflow-hidden" data-testid={testid}>
    <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-[#D4AF37]/10 blur-[120px]" />
    <div className="relative w-full max-w-md glass border border-[#D4AF37]/20 rounded-xl p-7 sm:p-10 shadow-[0_30px_80px_-20px_rgba(0,0,0,.8)] reveal">
      <img src="/img/logo-t.png" alt="Vienna Palace Hotel" className="h-20 w-auto mx-auto" />
      <p className="font-caps text-[10px] text-center text-zinc-500 mt-6">Área administrativa</p>
      <h1 className="font-display text-3xl text-center mt-2">{title}</h1>
      <div className="mt-8">{children}</div>
    </div>
  </div>
);

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email.trim(), password);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err, "Não foi possível entrar."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Entrar no painel" testid="admin-login-page">
      <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
        <div className="space-y-2">
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" data-testid="admin-input-email" type="email" autoComplete="username" inputMode="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="admin-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Senha</Label>
          <div className="relative">
            <Input id="password" data-testid="admin-input-password" type={show ? "text" : "password"} autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="admin-input pr-12" />
            <button type="button" data-testid="admin-toggle-password" onClick={() => setShow(!show)} className="absolute right-1 top-1 h-10 w-10 grid place-items-center text-zinc-400" aria-label="Mostrar senha">
              {show ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
        {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit-btn" className="btn-gold w-full h-12 disabled:opacity-60">
          {busy ? <Loader2 className="animate-spin" size={18} /> : "Entrar"}
        </button>
        <Link to="/admin/esqueci-senha" data-testid="admin-forgot-link" className="block text-center text-sm text-zinc-400 hover:text-[#E6C687]">Esqueci minha senha</Link>
      </form>
    </AuthShell>
  );
}
